
import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { Network } from "@/network";
import { LightBoxConfirm } from "@/components";

@Component<App>({
  components: {LightBoxConfirm}
})
export default class App extends Vue {
    private externalLightBoxConfirmInfo = {
    show: false,
    title: "",
    txt: "",
    cancel: "",
    confirm: "",
  };
  private externalTargetUrl = "";
  
  //判斷當前訪問網站跟點擊連結的hostname
  private isExternalUrl(url: string): boolean {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname !== window.location.hostname;
    } catch {
      return false;
    }
  }
  private handleLinkClick = (event: Event) => {
    const target = event.target as HTMLElement;
    if (target.tagName === "A") {
      const href = (target as HTMLAnchorElement).href;
      //排除href為空與http開頭
      if(!href || !href.startsWith('http')){
        return;
      }
      //檢查是否為外部連結
      if (href && this.isExternalUrl(href)) {
        event.preventDefault();
        this.openExternalLightBoxConfirm(href);
      }
    }
  };

  private openExternalLightBoxConfirm(url: string) {
    this.externalTargetUrl = url;
    this.externalLightBoxConfirmInfo.show = true;
    this.externalLightBoxConfirmInfo.title = "重要";
    this.externalLightBoxConfirmInfo.txt =
      "提醒您，您將離開合作金庫銀行官方網站，客戶隱私權保護及資訊安全事項將由進入網站業者負責。<br><br>若您同意繼續前往該網站，請選擇「確定」，不同意請選擇「取消」。";
    this.externalLightBoxConfirmInfo.cancel = "取消";
    this.externalLightBoxConfirmInfo.confirm = "確定";
  }

  private closeExternalLightBoxConfirm() {
    this.externalLightBoxConfirmInfo.show = false;
    this.externalTargetUrl = "";
  }

  private confirmExternalLightBoxConfirm() {
    this.externalLightBoxConfirmInfo.show = false;
    if (this.externalTargetUrl) {
      window.open(this.externalTargetUrl, "_blank");
    }
    this.externalTargetUrl = "";
  }

  public mounted() {
    document.addEventListener("click", this.handleLinkClick);
  }

  public beforeDestroy() {
    document.removeEventListener("click", this.handleLinkClick);
  }
  // private time = 60000;
  // private timeout = 600000;
  // private interval!: null | ReturnType<typeof setInterval>;
  // private current = +new Date();

  // public created() {
  //   this.interval = setInterval(() => {
  //     const now = +new Date();
  //     if (now - this.current > this.timeout) {
  //       this.current = +new Date();
  //       this.logout();
  //     }
  //   }, this.time);
  // }

  // public mounted() {
  //   document.addEventListener('click', this.updateCurrent);
  // }

  // private updateCurrent() {
  //   this.current = +new Date();
  // }

  // private logout() {
  //   if (window.location.href !== process.env.VUE_APP_BASE_URL + "/login") {
  //     Network.removeToken();
  //     Cookies.remove("appToken");
  //     Cookies.remove("appUserAuthPrivJson");
  //     Cookies.remove("loginType");
  //     Cookies.remove("appUserInfo");
  //     Cookies.remove("isAdmin");

  //     window.location.href = '/login';
  //   }
  // }
}
